import Vivus from 'vivus';

export default class InitVivus {
  constructor() {
    document.querySelectorAll('.js-hr').forEach(element => {
      if ( window.innerWidth > 640 ) {
        const id = element.getAttribute('id');
        const file = element.getAttribute('data-file');
        const duration = 110;
        new Vivus(id, {
          duration: duration,
          file: file,
          type: 'sync',
          animTimingFunction: Vivus.EASE_OUT,
        });
      }
    });

    const loading = document.getElementById('js-loading');
    if (loading != null) {
      const frameId = ( window.innerWidth > 640 ) ? 'js-loadingFrame' : 'js-loadingFrameSp';
      const anim = new Vivus(frameId, {
        duration: 110,
        type: 'sync',
        animTimingFunction: Vivus.EASE_OUT,
        onReady: function (myVivus) {
          myVivus.el.style.visibility = 'visible';
        },
      });
      var progress = 0;
      Object.defineProperty(anim.map[0], 'progress', {
        get: function () {
          return progress
        },
        set: function (v) {
          if (v === 1) callbackMagic(this)
          progress = v
        }
      })
    }

    function callbackMagic (pathObj) {
      document.getElementById('js-loading').classList.add('is-hidden');
      document.body.classList.add('loading-end');
    }
  }
}

document.addEventListener('DOMContentLoaded', event => {
  new InitVivus();
});
